export default "__VITE_ASSET__CSgst$tz__"